module.exports = __webpack_public_path__ + "static/media/face-wax.8434c5c0.jpg";